import React from 'react';
import styles from './NewsUpdates.module.scss';
import { Mixpanel } from '../../../../../../utils/mixpanel';
import { INVESTOR_OPEN_NEWS_ARTICLE } from '../../../../../../utils/constants/mixpanelEvents/investorEvents';
import { getTimeStamp } from '../../../../../../utils/dateUtils';
import { ctaPurpleRight } from '../../../../../../assets/hostedassets';
import dayjs from 'dayjs';
import A4Page from '../../../../../AicaPDFReport/A4Page/A4Page';
import clsx from 'clsx';
import { reportSectionsToShow } from '../../../../../AicaPDFReport/AicaPDFReport';
import { REPORT_SECTION_NAMES } from '../../../../../../store/pdfReport/pdfReport_constants';
import AIGeneratedBadge from '../../../../../../common/AIGeneratedBadge/AIGeneratedBadge';

interface NewsUpdatesProps {
    newsInfo;
    accessType;
    isPDFReport?: boolean;
}

const FALLBACK_IMG = 'https://fl-fe-assets.s3.ap-south-1.amazonaws.com/svg/news-fallback.svg';

const NewsUpdates: React.FC<NewsUpdatesProps> = ({ newsInfo, accessType = '', isPDFReport = false }) => {
    const onArticleClick = () => {
        Mixpanel.track(INVESTOR_OPEN_NEWS_ARTICLE, {
            Timestamp: getTimeStamp(),
            AICASection: accessType,
        });
    };

    if (!newsInfo?.news?.length) {
        return <></>;
    }

    const render = (
        <div className={styles.newsUpdates}>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h2 className={styles.heading}>News & Updates</h2>
                </div>
                <div className={styles.headerRight}>
                    <AIGeneratedBadge />
                </div>
            </div>

            <div className={styles.content}>
                <div className={clsx(styles.contentBody, { [styles.pdfReport]: isPDFReport })}>
                    {newsInfo?.news?.slice?.(0, 4)?.map((article, i) => (
                        <div className={styles.newsCard} key={i}>
                            <div className={styles.cardContent}>
                                <div className={styles.cardHeader}>
                                    <div className={styles.newsImage}>
                                        <img
                                            src={article?.imageUrl ?? FALLBACK_IMG}
                                            alt=""
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = FALLBACK_IMG;
                                            }}
                                        />
                                    </div>

                                    {article?.publishedDate && (
                                        <div className={styles.publishDate}>
                                            {dayjs(article?.publishedDate, 'DD-MM-YYYY', true).isValid()
                                                ? dayjs(article?.publishedDate, 'DD-MM-YYYY').format('MMM YY')
                                                : article?.publishedDate}
                                        </div>
                                    )}
                                </div>

                                <div className={styles.publisherName}>{article.publisherName}</div>

                                <div className={styles.newsTitle}>{article.title}</div>

                                <a
                                    className={styles.viewButton}
                                    href={article.redirectUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={onArticleClick}
                                >
                                    <img src={ctaPurpleRight} alt="" height={'14px'} />
                                    View News
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    if (isPDFReport)
        return newsInfo?.news?.length && reportSectionsToShow.includes(REPORT_SECTION_NAMES.NEWS_UPDATES) ? (
            <A4Page sectionName={REPORT_SECTION_NAMES.NEWS_UPDATES}>{render}</A4Page>
        ) : (
            <></>
        );
    else return render;
};

export default NewsUpdates;
